import classNames from "classnames";
import { Entry } from "contentful";
import { CSSProperties } from "react";

import Container from "~/components/common/container";
import Grid from "~/components/common/grid";
import Editorials from "~/types/editorials";
import { assertEditorialType, isActiveEntry } from "~/utils/editorial-utils";

import EditorialEntry from "../editorial-entry";
import styles from "./editorial-grid.module.scss";

type Props = {
  entry: Entry<unknown>;
};

export default function EditorialGrid(props: Props) {
  const MAX_GRID_COLUMNS = 12;

  if (!isActiveEntry(props.entry)) return null;

  assertEditorialType<Editorials.EditorialGrid>(props.entry, "editorialGrid");
  const { type, numberColumns, components, backgroundColor } = props.entry.fields;

  return (
    <div className={classNames(styles.container, backgroundColor ? styles[backgroundColor] : undefined)}>
      <Container>
        <Grid className={styles.grid}>
          {components?.filter(isActiveEntry).map((entry, index) => {
            if (type === "column" && numberColumns === index) return null;

            return (
              <div
                key={entry.sys.id}
                className={classNames(styles.gridColumn, type === "column" ? styles.column : undefined)}
                style={{ "--number-grid-columns": MAX_GRID_COLUMNS / numberColumns } as CSSProperties}
              >
                <EditorialEntry entry={entry} />
              </div>
            );
          })}
        </Grid>
      </Container>
    </div>
  );
}
